module.exports = __webpack_public_path__ + "img/21000.0130f97a.jpg";